/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type RollingWindowConfigUnit = (typeof RollingWindowConfigUnit)[keyof typeof RollingWindowConfigUnit];

export const RollingWindowConfigUnit = {
  day: 'day',
  week: 'week',
  month: 'month',
} as const;
